<div class="mat-headline-6">Study Programs</div>
<div fxLayout="row wrap" fxLayoutAlign="space-evenly stretch" fxLayoutGap="10px">
  @if (age) {
    <mat-card
      appearance="outlined"
      class="pointer"
      tabindex="0"
      (agInteract)="search(age.searchQuery, 'Age')"
    >
      <div mat-card-title>Recommended Age</div>
      <div mat-card-content align="center">
        <h3>{{ recommendedAge }}</h3>
        @if (age.grade) {
          <div>Grade {{ age.grade }}</div>
        }
      </div>
    </mat-card>
  }
  @if (studyProgram) {
    @if (studyProgram.lexile) {
      <mat-card
        appearance="outlined"
        class="pointer"
        tabindex="0"
        (agInteract)="search(studyProgram.lexile.searchQuery, 'Lexile')"
      >
        <div mat-card-title>Lexile</div>
        <div mat-card-content>
          <h3>{{ studyProgram.lexile.measure }}</h3>
          <div [matTooltip]="studyProgram.lexile.definition ?? null">
            {{ studyProgram.lexile.code }}
          </div>
        </div>
      </mat-card>
    }
    @if (studyProgram.acceleratedReader) {
      <mat-card
        appearance="outlined"
        class="pointer"
        tabindex="0"
        (agInteract)="search(studyProgram.acceleratedReader.searchQuery, 'Accelerated Reader')"
      >
        <div mat-card-title>Accelerated Reader</div>
        <div mat-card-content>
          <h3>{{ studyProgram.acceleratedReader.atos }}</h3>
          <div>Points: {{ studyProgram.acceleratedReader.titlePoint }}</div>
        </div>
      </mat-card>
    }
    @if (studyProgram.readingCounts) {
      <mat-card
        appearance="outlined"
        class="pointer"
        tabindex="0"
        (agInteract)="search(studyProgram.readingCounts.searchQuery, 'Reading Count')"
      >
        <div mat-card-title>Reading Counts</div>
        <div mat-card-content>
          <h3>{{ studyProgram.readingCounts.readingLevel }}</h3>
          <div>Points: {{ studyProgram.readingCounts.titlePoint }}</div>
        </div>
      </mat-card>
    }
  }
</div>
